// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { Customer2QualificationEntity } from '../../../entities/mdqx/customer2qualification.entity';
import {
    MutationCreateCustomer2QualificationArgs,
    MutationDeleteCustomer2QualificationArgs,
} from '../../../mdqx-graphql-types';


export enum Customer2QualificationActionTypes {
    GetRequest = '[Customer2Qualification] Get Request',
    GetResponse = '[Customer2Qualification] Get Response',
    PostRequest = '[Customer2Qualification] Post Request',
    PostResponse = '[Customer2Qualification] Post Response',
    DeleteRequest = '[Customer2Qualification] Delete Request',
    DeleteResponse = '[Customer2Qualification] Delete Response',
}

export class GetCustomer2QualificationRequest implements Action {
    readonly type = Customer2QualificationActionTypes.GetRequest;
}

export class GetCustomer2QualificationResponse implements Action {
    readonly type = Customer2QualificationActionTypes.GetResponse;
    constructor(public Payload: Customer2QualificationEntity[]) {}
}

export class PostCustomer2QualificationRequest implements Action {
    readonly type = Customer2QualificationActionTypes.PostRequest;
    constructor(public Payload: MutationCreateCustomer2QualificationArgs) {}
}

export class PostCustomer2QualificationResponse implements Action {
    readonly type = Customer2QualificationActionTypes.PostResponse;
    constructor(public Payload: Customer2QualificationEntity) {}
}

export class DeleteCustomer2QualificationRequest implements Action {
    readonly type = Customer2QualificationActionTypes.DeleteRequest;
    constructor(public Payload: MutationDeleteCustomer2QualificationArgs) {}
}

export class DeleteCustomer2QualificationResponse implements Action {
    readonly type = Customer2QualificationActionTypes.DeleteResponse;
    constructor(public Payload: { customerId: number; qualificationId: number }) {}
}

export type Customer2QualificationActions =
    | GetCustomer2QualificationRequest
    | GetCustomer2QualificationResponse
    | PostCustomer2QualificationRequest
    | PostCustomer2QualificationResponse
    | DeleteCustomer2QualificationRequest
    | DeleteCustomer2QualificationResponse;
